import { VariablesOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { env } from "#/utilities/env";
import { getInContextVariables } from "@repo/graphql-shopify-storefront";
import { Menu_Query } from "#/graphql/shopify-storefront/queries/menu";
import { fetcherShopifyStorefront } from "@repo/graphql-shopify-storefront";

export async function MenuQueryHandler({
  variables,
  lang,
}: {
  variables: VariablesOfShopifyStorefront<typeof Menu_Query>;
  lang: Navigator["language"];
}) {
  if (!lang) {
    console.error("No lang in MenuQueryHandler");
  }

  const inContextVariables = getInContextVariables(lang);

  const { menu } = await fetcherShopifyStorefront(Menu_Query, {
    ...inContextVariables,
    ...variables,
  });

  const items = menu?.items.map((item) => {
    const handle = item.url?.split("/").pop();

    const url = item.url
      ?.replace(`https://${env.NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN}`, "")
      .replace("/collections/", "/search/")
      .replace("/pages/", "/");

    return {
      ...item,
      handle,
      url,
    };
  });

  return { ...menu, items };
}
